module.exports = __webpack_public_path__ + "static/media/twitter.1b675875.png";